import React from "react";
import { styled } from "@glitz/react";
import {
  black,
  fontSize,
  fontWeight,
  spacing,
  green,
  red,
  orange,
  grey,
  lightGrey,
} from "../theme";
import { GrStatusGoodSmall } from "react-icons/gr";

interface StockLevelProps {
  status?: string;
}
const GetStatus = (status: string) => {
  switch (status) {
    case "instock":
      return (
        <>
          <StatusSymbol
            style={{
              color: green,
            }}
          />
          Finns i lager!
        </>
      );

    case "onbackorder":
      return (
        <>
          <StatusSymbol
            style={{
              color: orange,
            }}
          />
          Beställningsvara
        </>
      );

    case "outofstock":
      return (
        <>
          <StatusSymbol
            style={{
              color: red,
            }}
          />
          Slut i lager!
        </>
      );

    case "missingVariations":
      return <>Välj variant för att se lagersaldo</>;

    default:
      return (
        <>
          <StatusSymbol
            style={{
              color: grey,
            }}
          />
          Okänd status
        </>
      );
  }
};

const StockLevel: React.FC<StockLevelProps> = ({ status }) => {
  if (!status) return null;

  return (
    <StatusWrapper>
      <Label>Lagerstatus: </Label>
      <Status>{GetStatus(status)}</Status>
    </StatusWrapper>
  );
};

const StatusWrapper = styled.div({
  margin: { y: spacing.s },
});

const Label = styled.span({
  fontSize: fontSize.s,
  color: black,
  fontWeight: fontWeight.bold,
  marginBottom: spacing.xxs,
  display: "block",
});

const Status = styled.span({
  display: "flex",
  gap: spacing.xxs,
  alignItems: "center",
});

const StatusSymbol = styled(GrStatusGoodSmall, {});

export default StockLevel;
